import { Megaphone } from "lucide-react";

import { trpc } from "../lib/trpc";

/**
 * L'avviso di chi ha costruito il programma, all'apertura dell'app.
 *
 * Sta sopra al lavoro e non si chiude con una crocetta di lato: si chiude confermando di
 * averlo letto, ed e quel gesto a diventare la conferma di lettura che si vede dalla
 * console. Un avviso che si puo scacciare senza leggerlo non serve a chi lo ha scritto.
 *
 * Si mostra un messaggio alla volta, il piu recente, e si dice quanti ne restano: tre
 * riquadri sovrapposti all'apertura non li legge nessuno.
 */
export function OwnerAnnouncement() {
  const utils = trpc.useUtils();
  const daLeggere = trpc.announcements.daLeggere.useQuery(undefined, { refetchInterval: 60_000 });
  const segna = trpc.announcements.segnaLetto.useMutation({
    onSuccess: () => {
      void utils.announcements.invalidate();
    },
  });

  const avviso = daLeggere.data?.[0];
  if (!avviso) return null;
  const altri = (daLeggere.data?.length ?? 1) - 1;

  return (
    <div className="avviso-proprietario" role="status">
      <div className="avviso-proprietario__testo">
        <p className="eyebrow"><Megaphone size={16} aria-hidden="true" /> Messaggio da MANUTIO</p>
        <h2>{avviso.title}</h2>
        <p>{avviso.body}</p>
        {altri > 0 && (
          <p className="avviso-proprietario__coda">
            Poi ce n'{altri === 1 ? "e un altro" : `e altri ${altri}`}.
          </p>
        )}
      </div>
      <button
        type="button"
        className={`button button--primary${segna.isPending ? " button--saving" : ""}`}
        onClick={() => segna.mutate({ announcementId: avviso.announcementId })}
        disabled={segna.isPending}
      >
        {segna.isPending ? "Un attimo..." : "Ho letto"}
      </button>
    </div>
  );
}
